module.exports = __webpack_public_path__ + "img/horizontal_4_1_1.9f85011a.png";